import { z } from 'zod';
/**
 * The lifecycle of one soldier's hold on one thing (REQUIREMENTS §2.4).
 *
 * `expended` exists because consumables are never returned — without a closing
 * state of its own, every training day would read as a mass equipment loss
 * (§2.5, consumables).
 */
export const assignmentStatusSchema = z.enum([
    'pending_signature',
    /**
     * A transfer's receiving side: the receiver signed, and the item moves
     * onto them only when someone above everyone involved signs the transfer
     * off (owner, 2026-09-21). Until then the giver's assignment is the one
     * that is `active`.
     */
    'pending_approval',
    'active',
    'in_rotation',
    'returned',
    'transferred',
    'lost',
    'damaged',
    'expended',
    'cancelled',
    /**
     * Not in §2.4's list: the closing state of a write-off. A lost or damaged
     * item that will not come back leaves the books here, by a level-3 role.
     * Distinct from `expended` (a consumable used as
     * intended) so the ledger and the reports can tell the two apart.
     */
    'written_off',
]);
/**
 * Statuses that still put the item on the soldier's account.
 *
 * `lost` and `damaged` are deliberately open: the item is unaccounted for or
 * unusable but it has not been written off, and somebody is still answerable
 * for it. Releasing a soldier over an open loss report is exactly the silent
 * departure §2.7 forbids.
 *
 * This list is the single definition of "still holding something". The
 * deactivation guard and every gear view read it from here.
 */
export const OPEN_ASSIGNMENT_STATUSES = [
    'pending_signature',
    'pending_approval',
    'active',
    'in_rotation',
    'lost',
    'damaged',
];
export function isOpenAssignmentStatus(status) {
    return OPEN_ASSIGNMENT_STATUSES.includes(status);
}
//# sourceMappingURL=assignments.js.map